function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import './VectorTileLayer';
import olSourceVectorTile from 'ol/source/VectorTile';
import olLayerVectorTile from 'ol/layer/VectorTile';
import olFormatMVT from 'ol/format/MVT';
import TileGrid from 'ol/tilegrid/TileGrid';
import { createDefaultStyle } from 'ol/style/Style';
import { VectorTileModelBuilder } from './VectorTileModelBuilder';
import { stylefunction as mapboxStyleFunction } from 'ol-mapbox-style';
import { LAYER_ID, LAYER_TYPE, FEATURE_QUERY_ERRORS, VECTOR_STYLE } from '../../domain/constants';
import { getZoomLevelHelper } from '../../util/scale';
import { getFeatureAsGeojson } from '../../util/vectorfeatures/jsonHelper';
import { getMVTFeaturesInExtent } from '../../util/vectorfeatures/mvtHelper';
import { filterFeaturesByAttribute, filterFeaturesByGeometry } from '../../util/vectorfeatures/filter';
var AbstractVectorLayerPlugin = Oskari.clazz.get('Oskari.mapping.mapmodule.AbstractVectorLayerPlugin');
var LayerComposingModel = Oskari.clazz.get('Oskari.mapframework.domain.LayerComposingModel');

/**
 * @class Oskari.mapframework.mapmodule.VectorTileLayerPlugin
 * Provides functionality to draw vector tile layers on the map
 */
var VectorTileLayerPlugin = /*#__PURE__*/function (_AbstractVectorLayerP) {
  function VectorTileLayerPlugin(config) {
    var _this;
    _classCallCheck(this, VectorTileLayerPlugin);
    _this = _callSuper(this, VectorTileLayerPlugin, [config]);
    _this.__name = 'VectorTileLayerPlugin';
    _this._clazz = 'Oskari.mapframework.mapmodule.VectorTileLayerPlugin';
    _this.layertype = 'vectortile';
    return _this;
  }

  /**
   * @private @method _initImpl
   * Interface method for the module protocol.
   */
  _inherits(VectorTileLayerPlugin, _AbstractVectorLayerP);
  return _createClass(VectorTileLayerPlugin, [{
    key: "_initImpl",
    value: function _initImpl() {
      // register domain builder
      var mapLayerService = this.getSandbox().getService('Oskari.mapframework.service.MapLayerService');
      if (mapLayerService) {
        var composingModel = new LayerComposingModel([LayerComposingModel.ATTRIBUTIONS, LayerComposingModel.CREDENTIALS, LayerComposingModel.EXTERNAL_VECTOR_STYLES, LayerComposingModel.HOVER, LayerComposingModel.SRS, LayerComposingModel.VECTOR_STYLES, LayerComposingModel.TILE_GRID, LayerComposingModel.URL, LayerComposingModel.DECLUTTER], null, [LayerComposingModel.NAME]); // common field name is not used in vectortilelayers so it is skipped on LayerComposingModel

        mapLayerService.registerLayerModel(this.layertype + 'layer', this._getLayerModelClass(), composingModel);
        mapLayerService.registerLayerModelBuilder(this.layertype + 'layer', this._getModelBuilder());
      }
      this.getSandbox().getService('Oskari.mapframework.service.VectorFeatureService').registerLayerType(this.layertype, this);
    }

    /**
     * @private @method _getLayerModelClass
     * Returns class to be used as mapLayerService layer model
     */
  }, {
    key: "_getLayerModelClass",
    value: function _getLayerModelClass() {
      return 'Oskari.mapframework.mapmodule.VectorTileLayer';
    }

    /**
     * @private @method _getModelBuilder
     * Returns object to be used as mapLayerService layer model builder
     */
  }, {
    key: "_getModelBuilder",
    value: function _getModelBuilder() {
      return new VectorTileModelBuilder();
    }

    /**
     * @private @method _createPluginEventHandlers
     * Called by superclass to create event handlers
     */
  }, {
    key: "_createPluginEventHandlers",
    value: function _createPluginEventHandlers() {
      return {
        AfterChangeMapLayerStyleEvent: function AfterChangeMapLayerStyleEvent(event) {
          var oskariLayer = event.getMapLayer();
          this._updateLayerStyle(oskariLayer);
        }
      };
    }

    /**
     * @private @method _updateLayerStyle
     * @param {Oskari.mapframework.mapmodule.VectorTileLayer} oskariLayer
     */
  }, {
    key: "_updateLayerStyle",
    value: function _updateLayerStyle(oskariLayer) {
      var olLayers = this.getOLMapLayers(oskariLayer);
      if (olLayers && olLayers.length > 0) {
        olLayers[0].setStyle(this._getLayerCurrentStyleFunction(oskariLayer));
      }
    }

    /**
     * @private @method _getLayerCurrentStyleFunction
     * Returns OL style corresponding to layer currently selected style
     * @param {Oskari.mapframework.domain.AbstractLayer} layer
     * @return {ol/style/Style}
     */
  }, {
    key: "_getLayerCurrentStyleFunction",
    value: function _getLayerCurrentStyleFunction(layer) {
      var olLayers = this.getOLMapLayers(layer.getId());
      var style = layer.getCurrentStyle();
      if (style.getType() === VECTOR_STYLE.MAPBOX && olLayers.length !== 0) {
        var styleDef = style.getFeatureStyle();
        var sourceLayerIds = styleDef.layers.filter(function (cur) {
          return !!cur.source;
        }).map(function (cur) {
          return cur.id;
        });
        var resolutions = _toConsumableArray(this.getMapModule().getResolutionArray());
        return mapboxStyleFunction(olLayers[0], styleDef, sourceLayerIds, resolutions);
      }
      return style.hasDefinitions() ? this.mapModule.getStyleForLayer(layer) : this._createDefaultStyle();
    }

    /**
     * @private @method _createDefaultStyle
     * Creates OL style or style function for default style
     * @return {ol/style/Style}
     */
  }, {
    key: "_createDefaultStyle",
    value: function _createDefaultStyle() {
      return createDefaultStyle;
    }

    /**
     * Checks if the layer can be handled by this plugin
     * @method  isLayerSupported
     * @param  {Oskari.mapframework.domain.AbstractLayer} layer
     * @return {Boolean}       true if this plugin handles the type of layers
     */
  }, {
    key: "isLayerSupported",
    value: function isLayerSupported(layer) {
      if (!layer) {
        return false;
      }
      return layer.isLayerOfType(this.layertype);
    }

    /**
     * @method getAttributions
     * @param  {Oskari.mapframework.domain.AbstractLayer} layer
     * @return {Array<String>} layer attributions
     */
  }, {
    key: "getAttributions",
    value: function getAttributions(layer) {
      if (!layer) {
        return;
      }
      var _layer$getOptions = layer.getOptions(),
        attributions = _layer$getOptions.attributions;
      if (!attributions) {
        return;
      }
      if (!Array.isArray(attributions)) {
        attributions = [attributions];
      }
      return attributions.map(function (obj) {
        if (typeof obj === 'string') {
          return obj;
        }
        var label = obj.label,
          link = obj.link;
        return link ? "<a href=\"".concat(link, "\">").concat(label, "</a>") : label;
      });
    }
  }, {
    key: "getUrlParams",
    value: function getUrlParams(layer) {
      if (!layer.getParams()) {
        return null;
      }
      var params = layer.getParams();
      return Object.keys(params).map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
      }).join('&');
    }

    /**
     * Override in actual plugins to returns features.
     *
     * Returns features that are currently on map filtered by given geometry and/or properties
     * {
     *   "[layer id]": {
            accuracy: 'extent',
     *      features: [{ geometry: {...}, properties: {...}}, ...]
     *   },
     *   ...
     * }
     * For features that are queried from MVT-tiles we might not be able to get the whole geometry and since it's not accurate they will
     *  only get the extent of the feature. This is marked with accuracy: 'extent' and it might not even be the whole extent if the
     *  feature continues on unloaded tiles.
     * @param {Object} geojson an object with geometry and/or properties as filter for features. Geometry defaults to current viewport.
     * @param {Object} opts additional options to narrow feature collection
     * @returns {Object} an object with layer ids as keys with an object value with key "features" for the features on that layer and optional runtime-flag
     */
  }, {
    key: "getFeatures",
    value: function getFeatures() {
      var _this2 = this;
      var geojson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // console.log('getting features from ', this.getName());
      var _this$getSandbox$getM = this.getSandbox().getMap().getBbox(),
        left = _this$getSandbox$getM.left,
        bottom = _this$getSandbox$getM.bottom,
        right = _this$getSandbox$getM.right,
        top = _this$getSandbox$getM.top;
      var extent = [left, bottom, right, top];
      var layers = opts.layers;
      if (!layers || !layers.length) {
        layers = this.getSandbox().getMap().getLayers().map(function (l) {
          return l.getId();
        });
      }
      var result = {};
      layers.forEach(function (layerId) {
        var layer = _this2.getSandbox().getMap().getSelectedLayer(layerId);
        if (!_this2.isLayerSupported(layer)) {
          return;
        }
        var err = _this2.detectErrorOnFeatureQuery(layer);
        if (err) {
          result[layerId] = {
            error: err,
            features: []
          };
          return;
        }
        var layerImpls = _this2.getOLMapLayers(layerId);
        if (!layerImpls || !layerImpls.length) {
          result[layerId] = {
            error: FEATURE_QUERY_ERRORS.NOT_FOUND,
            features: []
          };
          return;
        }
        var features = getMVTFeaturesInExtent(layerImpls[0].getSource(), extent);
        if (!features) {
          return;
        }
        var geojsonFeatures = features.map(function (feat) {
          return getFeatureAsGeojson(feat);
        });
        if (geojson.geometry) {
          geojsonFeatures = filterFeaturesByGeometry(geojsonFeatures, geojson.geometry);
        }
        if (geojson.properties) {
          geojsonFeatures = filterFeaturesByAttribute(geojsonFeatures, geojson.properties);
        }
        result[layerId] = {
          accuracy: 'extent',
          features: geojsonFeatures
        };
      });
      return result;
    }

    /**
     * @method addMapLayerToMap
     * @private
     * Adds a single vector tile layer to this map
     * @param {Oskari.mapframework.domain.VectorTileLayer} layer
     * @param {Boolean} keepLayerOnTop
     * @param {Boolean} isBaseMap
     */
  }, {
    key: "addMapLayerToMap",
    value: function addMapLayerToMap(layer, keepLayerOnTop, isBaseMap) {
      var _this3 = this;
      if (!this.getSandbox().getMap().isLayerSupported(layer)) {
        return;
      }
      var url = layer.getLayerUrl().replace('{epsg}', this.mapModule.getProjection());
      var urlParams = this.getUrlParams(layer);
      if (urlParams) {
        var paramsPrefix = url.includes('?') ? '&' : '?';
        url = url + paramsPrefix + urlParams;
      }
      var sourceOpts = {
        format: new olFormatMVT(),
        url: url,
        projection: this.getMap().getView().getProjection(),
        // OL projection object
        attributions: this.getAttributions(layer)
      };
      var tileGrid = layer.getTileGrid();
      if (tileGrid) {
        sourceOpts.tileGrid = new TileGrid(tileGrid);
      }
      // options is used to store tile grid and all sorts of other flags so only get the
      //  declutter option here instead of spreading the object to layer directly
      //  className -> to get decluttered labels rendered in layer order (https://github.com/openlayers/openlayers/issues/13235)
      var _ref = layer.getOptions() || {},
        declutter = _ref.declutter,
        _ref$className = _ref.className,
        className = _ref$className === void 0 ? 'ol-layer' : _ref$className;
      var vectorTileLayer = new olLayerVectorTile({
        opacity: layer.getOpacity() / 100,
        visible: layer.isInScale(this.getMapModule().getMapScale()) && layer.isVisible(),
        renderMode: 'hybrid',
        source: this.createSource(layer, sourceOpts),
        declutter: declutter,
        className: className
      });
      var zoomLevelHelper = getZoomLevelHelper(this.getMapModule().getScaleArray());
      // Set min max zoom levels that layer should be visible in
      zoomLevelHelper.setOLZoomLimits(vectorTileLayer, layer.getMinScale(), layer.getMaxScale());
      var vectorFeatureService = this.getSandbox().getService('Oskari.mapframework.service.VectorFeatureService');
      var hoverLayer = vectorFeatureService.registerHoverLayer(layer, vectorTileLayer.getSource());
      var olLayers = [vectorTileLayer, hoverLayer];
      olLayers.forEach(function (olLayer) {
        // Properties id and type are being used in VectorFeatureService.
        // Set oskari properties for vector feature service functionalities.
        var silent = true;
        olLayer.set(LAYER_ID, layer.getId(), silent);
        olLayer.set(LAYER_TYPE, layer.getLayerType(), silent);
        _this3.mapModule.addLayer(olLayer, !keepLayerOnTop);
      });
      this.setOLMapLayers(layer.getId(), olLayers);
      vectorTileLayer.setStyle(this._getLayerCurrentStyleFunction(layer));
    }
  }, {
    key: "createSource",
    value: function createSource(layer, options) {
      return new olSourceVectorTile(options);
    }

    /**
     * Called when layer details are updated (for example by the admin functionality)
     * @param {Oskari.mapframework.domain.AbstractLayer} layer new layer details
     */
  }, {
    key: "_updateLayer",
    value: function _updateLayer(layer) {
      if (!this.isLayerSupported(layer)) {
        return;
      }
      var zoomLevelHelper = getZoomLevelHelper(this.getMapModule().getScaleArray());
      var layersImpls = this.getOLMapLayers(layer.getId()) || [];
      layersImpls.forEach(function (olLayer) {
        // Update min max Resolutions
        zoomLevelHelper.setOLZoomLimits(olLayer, layer.getMinScale(), layer.getMaxScale());
      });
    }
  }]);
}(AbstractVectorLayerPlugin);
Oskari.clazz.defineES('Oskari.mapframework.mapmodule.VectorTileLayerPlugin', VectorTileLayerPlugin, {
  /**
   * @property {String[]} protocol array of superclasses as {String}
   * @static
   */
  'protocol': ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});
export { VectorTileLayerPlugin };